export default __webpack_public_path__ + "static/media/3.826bb006.png";